<template>
  <div class="kbbb" v-if="kbxmlc">
    <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
      <div class="clear">
        <p class="cont-title lf">开标报表</p>
        <div class="rt">
          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getData"
            ></el-button>
          </el-input>
          <!-- <el-button size="big" type="primary" @click="handletwo"
            >测试按钮</el-button
          > -->
          <template v-if="role != 'Z'">
            <el-button type="primary" @click="getKpdjgb" v-if="sfykpdjgb"
              >显示开评定结果表</el-button
            >
          </template>
          <el-button
            type="primary"
            @click="kqqr"
            :class="[t ? 'djsBtn' : '']"
            :disabled="sfszqrsj"
            v-if="role == 'Z'"
            >{{ t ? t : "开启确认" }}</el-button
          >
          <el-button
            type="primary"
            @click="scBb"
            v-if="role == 'Z'"
            :disabled="waitLoading"
            >生成报表</el-button
          >
          <el-popover
            placement="bottom"
            popper-class="kbbbPop"
            v-model="showBtns"
            :disabled="!isScbb"
          >
            <ul class="loadBtns" v-if="wjList && wjList.length">
              <li
                v-for="item in wjList"
                :key="item.id"
                @click="loadBb(item.id)"
              >
                {{ item.wjmc }}
              </li>
            </ul>
            <el-button
              :class="{ show: isScbb && !waitLoading }"
              slot="reference"
              :disabled="waitLoading"
              >下载</el-button
            >
          </el-popover>
        </div>
      </div>
      <el-table
        ref="table"
        border
        :data="tableData"
        style="width: 100%"
        max-height="570"
      >
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column
          prop="fcqymc"
          label="投标单位名称"
          show-overflow-tooltip
          min-width="180"
        ></el-table-column>
        <template v-if="aaa">
          <el-table-column
            prop="tbbj"
            :label="key"
            width="140"
            v-for="(val, key, index) in tableHead"
            :key="index"
            show-overflow-tooltip
          >
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            :prop="val"
            :label="key"
            width="140"
            v-for="(val, key, index) in tableHead"
            :key="index"
            show-overflow-tooltip
          >
          </el-table-column>
        </template>
        <el-table-column prop="sfqr" label="投标人确认" width="100">
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.sfqr">已确认</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="clear">
        <span class="lf pageNum"
          >共{{ total }}家，已确认{{ yqr }}家，待确认{{ total - yqr }}家。</span
        >
      </div>
    </div>
    <el-button
      type="primary lcNext"
      :disabled="!isScbb || waitLoading"
      @click="nextBtn"
      v-if="kbxmlc.zt != '2' && role == 'Z'"
      >下一步</el-button
    >
    <!-- 设置时间 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox">
        <div>
          <span>设置开标结果确认时间</span>
          <el-input
            type="number"
            v-model.number="time"
            style="width: 120px"
          ></el-input>
          分钟
        </div>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="saveTime" :disabled="waitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 开评定弹窗 -->
    <el-dialog
      title="报表"
      :visible.sync="bbVisible"
      :close-on-click-modal="false"
      :fullscreen="true"
    >
      <div class="pdf">
        <iframe
          :src="kpdjgbPdf"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </div>
      <div class="btnBox">
        <el-button
          type="primary"
          @click="kpdjgbTbr"
          :disabled="sfkpdjgbtbr"
          v-if="role == 'A' || role == 'T'"
          >{{ sfkpdjgbtbr ? "已推送" : "推送投标人" }}</el-button
        >
        <el-button type="primary" @click="bbVisible = false">关闭</el-button>
        <el-button type="primary" @click="loadKpdjgb">下载</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "kbbb",
  components: {},
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", //当前节点状态
      tableHead: {},
      tableData: [],
      wjList: [],
      yqr: 0,
      tbdwmc: "",
      isScbb: false, //是否已生成报表
      showBtns: false, //是否显示生成报表操作
      sfykpdjgb: false, //是否显示开评定结果按钮
      sfkpdjgbtbr: false, //是否开启过显示开评定结果按钮
      dialogVisible: false,
      time: 5,
      intervalKbbb: null,
      t: "",
      sfszqrsj: false,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      bbVisible: false,
      kpdjgbPdf: "",
      pdfId: "",
      lcSteps: JSON.parse(
        localStorage.getItem("lcSteps") ? localStorage.getItem("lcSteps") : ""
      ),
      aaa: false,
    };
  },
  created() {
    this.aaa = this.lcSteps.some((item) => {
      return item.ycmc.includes("多次报价");
    });
  },
  methods: {
    getData() {
      let para = {
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      clearInterval(this.intervalKbbb);
      this.intervalKbbb = null;
      this.$api
        .getkbbbData(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableHead = res.data.data.bjxsmc;
            this.kbxmlc = res.data.data.kbxmlc;
            this.total = res.data.data.data.total;
            this.yqr = res.data.data.data.yqrSize;
            this.sfykpdjgb = res.data.data.sfykpdjgb;
            this.sfkpdjgbtbr = res.data.data.kbxm.kpdjgbtbr == 0 ? false : true;
            if (res.data.data.tbdwMap) {
              var arr = res.data.data.data.tbdwList;
              arr.forEach((item, index) => {
                for (let key in res.data.data.tbdwMap[item.id]) {
                  item[key] = res.data.data.tbdwMap[item.id][key];
                }
              });
              this.tableData = arr;
            } else {
              this.tableData = res.data.data.data.tbdwList;
            }
            if (res.data.data.sfscwj) {
              this.isScbb = true;
              this.wjList = res.data.data.zhwjList;
            }
            if (res.data.data.sfszqrsj !== "") {
              this.sfszqrsj = true;
              var djs = res.data.data.sfszqrsj;
              if (djs >= 1000) {
                this.kbbbshenyuFun(djs);
              } else {
                clearInterval(this.intervalKbbb);
                this.intervalKbbb = null;
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    handletwo() {
      this.$api.xzcsbb().then((res) => {
        console.log(res);
        if (res.data.meta.success) {
          this.downloadFile(res.data.data);
        }
      });
    },
    downloadFile(data) {
      let para = {
        str: data,
      };
      this.$api
        .downloadcsb(para)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //打开开评定结果弹窗
    getKpdjgb() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .getKpdjgb(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.bbVisible = true;
            this.kpdjgbPdf = res.data.data.pdfFile;
            this.pdfId = res.data.data.id;
            console.log("res", res);
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    loadKpdjgb() {
      let para = {
        id: this.pdfId,
      };
      this.waitLoading = true;
      this.$api
        .loadKpdjgb(para)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //开启确认
    kqqr() {
      this.dialogVisible = true;
      this.time = 5;
    },
    //保存时间
    saveTime() {
      let para = {
        qrsj: Number(this.time),
      };
      this.waitLoading = true;
      this.$api
        .saveKqqrTime(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: "保存成功！",
            });
            this.getData();
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //生成报表
    scBb() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .scbb(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.$message({
              type: "success",
              message: "报表生成成功！",
            });
            this.isScbb = true;
            this.wjList = res.data.data.zhwjList;
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch((err) => {
          this.$message({
              type: "error",
              message: err.data.meta.message,
            });
          this.waitLoading = false;
        });
    },
    //下载报表
    loadBb(id) {
      if (this.waitLoading) return false;
      let para = {
        id: id,
      };
      this.waitLoading = true;
      this.$api
        .loadBb(para)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    nextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("nextBtn", para);
    },
    //计算剩余时间倒计时
    kbbbshenyuFun(djs) {
      var _this = this;
      var time = Number(djs);
      var flag = false;
      _this.intervalKbbb = setInterval(function () {
        if (time < 1000) {
          clearInterval(_this.intervalKbbb);
          _this.intervalKbbb = null;
          if (!flag) {
            flag = true;
            _this.getData();
          }
          _this.t = "";
          return;
        }
        time = time - 1000;
        var shengyuM = parseInt(time / (60 * 1000)); //毫秒数转换成分钟
        var M = time - shengyuM * 60 * 1000; //除去天、小时、分的毫秒数
        var S = parseInt(M / 1000); //除去天、小时、分的毫秒数转化为秒
        var ss = String(S);
        var mm = String(shengyuM);
        if (ss.length == 1) ss = "0" + ss;
        if (mm.length == 1) mm = "0" + mm;
        _this.t = mm + ":" + ss;
      }, 1000);
    },
    kpdjgbTbr() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .kpdjgbTbr(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.$message({
              type: "success",
              message: "推送投保人成功！",
            });
            this.sfkpdjgbtbr = true;
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.intervalKbbb);
    this.intervalKbbb = null;
  },
};
</script>
<style lang="less">
.kbbb {
  .dialogBox {
    padding: 50px 80px;
    span {
      font-size: 16px;
      color: #333;
      margin-right: 10px;
    }
    .el-input__inner {
      padding: 0 0 0 15px;
    }
  }
  span > .el-button.show {
    margin-left: 10px;
    background: @base-color;
    color: #fff;
  }
  span > .el-button.show:hover,
  span > .el-button.show:focus {
    background: fade(@base-color, 80%);
    color: #fff;
  }
  span > .el-button,
  span > .el-button:hover,
  span > .el-button:focus {
    background: #ccc;
    margin-left: 10px;
    color: #fff;
  }
  .el-button--primary.is-disabled.djsBtn {
    color: #d70a30;
    font-size: 18px;
  }
}
.el-popover.kbbbPop {
  min-width: 100px;
  padding: 0px;
  border: 1px solid @base-color;
  background: @bg;
  .loadBtns {
    li {
      list-style: none;
      height: 35px;
      line-height: 35px;
      color: @base-color;
      padding: 0 12px;
      cursor: pointer;
    }
    li + li {
      border-top: 1px solid @base-color;
    }
  }
}

.el-popper[x-placement^="bottom"].kbbbPop .popper__arrow {
  border-bottom-color: @base-color;
}
.el-popper[x-placement^="bottom"].kbbbPop .popper__arrow::after {
  border-bottom-color: @bg;
}
.el-dialog__body {
  height: 100%;
  .pdf {
    height: calc(~"100% - 60px");
    margin-bottom: 10px;
  }
}
</style>